import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import { Sidebar } from './Sidebar';

export const SidebarContainer = withRouter(compose(connect(undefined))(Sidebar));
